import React from "react"
import Prismic from "prismic-javascript"
import { Document } from "prismic-javascript/types/documents"

import { PRISMIC_URL } from "../../config"
import Loading from "./Loading"
import SliceZones from "./articles/SliceZones"
import { Text } from "./articles/slices"

/**
 * Pull content from Prismic, to be embedded. Note that this isn't
 * intended to be used as a landing page, but rather some
 * block of content we put somewhere on the site.
 */

const client = Prismic.client(PRISMIC_URL)

type Props = {
  uid: string
  showPageTitle?: boolean
}

const CMSContent = ({ uid, showPageTitle }: Props) => {
  const [content, setContent] = React.useState<Document | null>(null)
  const [isLoading, setIsLoading] = React.useState<boolean>(true)
  const [isError, setIsError] = React.useState<boolean>(false)

  React.useEffect(() => {
    const fetchPrismicData = async () => {
      setIsLoading(true)
      setIsError(false)
      const doc = await client.getByUID("website_page", uid, {})
      if (doc) {
        setContent(doc)
      } else {
        setIsError(true)
      }
      setIsLoading(false)
    }
    fetchPrismicData()
  }, [uid])

  if (isError) {
    return <p>There was an error fetching the content.</p>
  }

  if (isLoading || !content) {
    return <Loading />
  }

  return (
    <>
      {showPageTitle && content.data.pageTitle?.length > 0 && (
        <Text slice={{ primary: { content: content.data.pageTitle } }} />
      )}
      <SliceZones sliceZones={content.data.body} />
    </>
  )
}

export default CMSContent
